@if (invoices && invoices.length > 0) {
  <div class="open-invoices">
    <table mat-table [dataSource]="invoices" [trackBy]="trackByFn" class="open-invoices__table mat-elevation-z1">
      <ng-container matColumnDef="recordId">
        <th mat-header-cell *matHeaderCellDef class="open-invoices__th">Invoice No.</th>
        <td mat-cell *matCellDef="let row" class="open-invoices__td open-invoices__td--id"><div class="open-invoices__view" (click)="viewInvoice(row)">{{ row.recordId }}</div></td>
        <td mat-footer-cell *matFooterCellDef class="open-invoices__td"></td>
      </ng-container>
      <ng-container matColumnDef="datePosted">
        <th mat-header-cell *matHeaderCellDef class="open-invoices__th">Invoice Date</th>
        <td mat-cell *matCellDef="let row" class="open-invoices__td open-invoices__td--date">
          {{ row.datePosted | date:'M/d/yyyy' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="open-invoices__td"></td>
      </ng-container>
      <ng-container matColumnDef="invoiceAmount">
        <th mat-header-cell *matHeaderCellDef class="open-invoices__th">Invoice Amount</th>
        <td mat-cell *matCellDef="let row" class="open-invoices__td open-invoices__td--amount">
          {{ row.totalDue | currency:row.baseCurrency:'symbol':'1.2-2' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="open-invoices__td"></td>
      </ng-container>
      <ng-container matColumnDef="totalDue">
        <th mat-header-cell *matHeaderCellDef class="open-invoices__th">Total Due</th>
        <td mat-cell *matCellDef="let row" class="open-invoices__td open-invoices__td--amount">
          {{ row.totalDue | currency:row.baseCurrency:'symbol':'1.2-2' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="open-invoices__total-label open-invoices__td--amount">Total</td>
      </ng-container>
      <ng-container matColumnDef="paymentAmount">
        <th mat-header-cell *matHeaderCellDef class="open-invoices__th">Payment Amount</th>
        <td mat-cell *matCellDef="let row" class="open-invoices__td open-invoices__td--amount">
          {{ row.paymentAmount ?? 0 | currency:row.baseCurrency:'symbol':'1.2-2' }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="open-invoices__tr"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="open-invoices__tr"></tr>
    </table>
  </div>
}

@if (invoices && invoices.length === 0) {
  <div>
    <p class="open-invoices__not-found">No open invoices found.</p>
  </div>
}
